module.exports = __webpack_public_path__ + "img/JalilKakaWais-RaportyPapu.926e7021.jpg";